//imports
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { ExceptionManager } from 'Core/logManager';
import { endpoints } from 'Core/defaultValues';

//Action types
import {
    DEALERS_CREATE_EDIT_DEALER_SEARCH_ROLES_REQUEST,
    DEALERS_CREATE_EDIT_DEALER_GET_ROLE_REQUEST,
    DEALERS_CREATE_EDIT_DEALER_GET_DEALER_REQUEST,
    DEALERS_CREATE_EDIT_DEALER_GET_CUSTOM_ROLE_REQUEST,
    DEALERS_CREATE_EDIT_DEALER_GET_ROLE_MODULES_TEMPLATE_REQUEST,
    DEALERS_EDIT_DEALER_REQUEST,
    DEALERS_CREATE_DEALER_REQUEST,
    DEALERS_CREATE_EDIT_DEALER_SEARCH_TIMEZONES_REQUEST,
    DEALERS_CREDENCIAL_VALIDATION_REQUEST
} from 'Redux/actionTypes';

//Actions
import {
    dealersSearchRolesResult,
    dealersGetDealerResult,
    dealersGetRoleResult,
    dealersCreateDealerResult,
    dealersGetCustomRoleResult,
    dealersEditDealerResult,
    dealersGetRoleModuleTemplateResult,
    dealersSearchTimeZonesResult,
    dealersCredencialValidationResult,
} from 'Redux/actions';

function* credencialValidation({ payload }) {
    try {
        let QUERY = `
        query getWexLogin ($username: String!, $password: String!) {
            result: getWexLogin (username: $username, password: $password)
        }`

        let data = yield call(
            clientQuery,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL
        );

        if (data.result) {
            yield put(dealersCredencialValidationResult({ success: true }))
        } else {
            yield put(dealersCredencialValidationResult({ error: true }))
        }

    } catch (exc) {
        yield put(dealersCredencialValidationResult({ error: true }))
        ExceptionManager(exc, 'Modules/dealers/views/components/createEditDealer/redux/saga', 'searchRoles');
    }
}
function* searchRoles({ payload }) {
    try {
        let QUERY = `
        query searchRoles ($conditions: [RoleSearchInput], $sort: [RoleSortInput], $limit: Int, $offset: Int) {
            result: searchRoles (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                items {
                    id
                    name
                }
                total
            }
        }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                conditions: [
                    {
                        fields: ["dealerId"],
                        terms: [payload],
                        exact: true
                    },
                    {
                        fields: ["isCustom"],
                        terms: [false],
                        exact: true
                    }
                ],
                limit: 1000,
                offset: 0
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            const { items } = data?.result;
            yield put(dealersSearchRolesResult(items))
        } else {
            yield put(dealersSearchRolesResult([]))
        }

    } catch (exc) {
        yield put(dealersSearchRolesResult([]))
        ExceptionManager(exc, 'Modules/dealers/views/components/createEditDealer/redux/saga', 'searchRoles');
    }
}

function* getRole({ payload }) {
    try {
        let QUERY = `
            query searchRoleModules ($conditions: [RoleModuleSearchInput], $sort: [RoleModuleSortInput], $limit: Int, $offset: Int) {
                result: searchRoleModules (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                    items {
                        id
                        roleId
                        moduleId
                        module {
                            id
                            projectId
                            code
                            userCode
                            name
                            groupName
                            parentModuleId
                            category
                            modulesCount
                            parentModuleName
                        }
                        isDefault
                    }
                    total
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                conditions: {
                    fields: ["roleId"],
                    terms: [payload],
                    exact: true
                },
                sort: {
                    field: "module_name",
                    order: "ASC"
                },
                limit: 2000,
                offset: 0
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            const { items } = data.result;
            yield put(dealersGetRoleResult(items))
        } else yield put(dealersGetRoleResult([]))

    } catch (exc) {
        yield put(dealersGetRoleResult([]))
        ExceptionManager(exc, 'Modules/dealers/views/components/createEditDealer/redux/saga', 'getRole');
    }
}

function* getDealer({ payload }) {
    try {
        let QUERY = `
            query getDealer ($id: Int!) {
                result: getDealer (id: $id) {
                    id
                    name
                    username
                    email
                    masterCompanyId
                    masterCompany {
                        id
                        language
                        timezoneId
                        name
                    }
                    brandId
                    brand {
                        id
                        title
                    }
                    createdBy
                    createdOn
                    updatedBy
                    updatedOn
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                id: payload
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            yield put(dealersGetDealerResult(data?.result))
        }

    } catch (exc) {
        ExceptionManager(exc, 'Modules/dealers/views/components/createEditDealer/redux/saga', 'getRole');
    }
}

function* createDealer({ payload }) {
    try {
        let QUERY = `
            mutation createDealer ($name: String!, $masterCompanyId: Int, $email: String!, $username: String!, $password: String!, $language: Int!, $timezoneId: Int!, $brandId: Int!) {
                result: createDealer (name: $name, masterCompanyId: $masterCompanyId, email: $email, username: $username, password: $password, language: $language, timezoneId: $timezoneId, brandId: $brandId) {
                    id
                    name
                    masterCompanyId
                    masterCompany {
                        id
                        dealerId
                        name
                    }
                    brandId
                    brand {
                        id
                        title
                    }
                    email
                    username
                    createdBy
                    createdOn
                    updatedBy
                    updatedOn
                }
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            yield put(dealersCreateDealerResult(data?.result))
        } else {
            yield put(dealersCreateDealerResult({ error: true }))
        }

    } catch (exc) {
        yield put(dealersCreateDealerResult({ error: true }))
        ExceptionManager(exc, 'Modules/dealers/views/components/createEditDealer/redux/saga', 'createDealer', true);
    }
}

function* getCustomRol({ payload }) {
    try {
        let QUERY = `
            query searchRoleModules ($conditions: [RoleModuleSearchInput], $sort: [RoleModuleSortInput], $limit: Int, $offset: Int) {
                result: searchRoleModules (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                    items {
                        id
                        roleId
                        moduleId
                        module {
                            id
                            projectId
                            code
                            userCode
                            name
                            groupName
                            parentModuleId
                            category
                            modulesCount
                            parentModuleName
                        }
                        c
                        u
                        d
                        isDefault
                    }
                    total
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                conditions: [
                    {
                        fields: ["roleId"],
                        terms: [payload],
                        exact: true
                    }
                ],
                sort: {
                    field: "module_name",
                    order: "ASC"
                },
                limit: 2000,
                offset: 0
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            const { items } = data.result
            yield put(dealersGetCustomRoleResult(items))
        } else yield put(dealersGetCustomRoleResult([]))

    } catch (exc) {
        yield put(dealersGetCustomRoleResult([]))
        ExceptionManager(exc, 'Modules/dealers/views/components/createEditDealer/redux/saga', 'getCustomRol');
    }
}

function* editDealer({ payload }) {
    try {
        let QUERY = `
            mutation updateDealer ($id: Int!, $name: String, $brandId: Int!) {
                result: updateDealer (id: $id, name: $name, brandId: $brandId) {
                    id
                    name
                    masterCompanyId
                    masterCompany {
                        id
                        dealerId
                        name
                    }
                    brandId
                    brand {
                        id
                        title
                    }
                    email
                    username
                    createdBy
                    createdOn
                    updatedBy
                    updatedOn
                }
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            yield put(dealersEditDealerResult(data?.result))
        }

    } catch (exc) {
        yield put(dealersEditDealerResult({ error: true }))
        ExceptionManager(exc, 'Modules/dealers/views/components/createEditDealer/redux/saga', 'editDealer', true);
    }
}

function* searchTemplateRoleModules({ payload }) {
    try {
        let QUERY = `
            query searchRoleModules ($conditions: [RoleModuleSearchInput], $sort: [RoleModuleSortInput], $limit: Int, $offset: Int) {
                result: searchRoleModules (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                    items {
                        id
                        roleId
                        moduleId
                        module {
                            id
                            projectId
                            code
                            userCode
                            name
                            groupName
                            parentModuleId
                            category
                            modulesCount
                            parentModuleName
                        }
                        c
                        u
                        d
                        isDefault
                    }
                    total
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                conditions: [
                    {
                        fields: ["roleId"],
                        terms: [payload],
                        exact: true
                    }
                ],
                sort: {
                    field: "module_name",
                    order: "ASC"
                },
                limit: 2000,
                offset: 0
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            const { items } = data?.result
            yield put(dealersGetRoleModuleTemplateResult(items))
        } else yield put(dealersGetRoleModuleTemplateResult([]))

    } catch (exc) {
        yield put(dealersGetRoleModuleTemplateResult([]));
        ExceptionManager(exc, 'Modules/dealers/views/components/createEditDealer/redux/saga', 'searchTemplateRoleModules');
    }
}

function* searchTimezones() {
    try {
        let QUERY = `
            query searchTimezones ($conditions: [TimezoneSearchInput], $sort: [TimezoneSortInput], $limit: Int, $offset: Int) {
                result: searchTimezones (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                    items {
                        id
                        name
                    }
                    total
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                conditions: [],
                limit: 600,
                offset: 0
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            const { items } = data?.result
            yield put(dealersSearchTimeZonesResult(items))
        }

    } catch (exc) {
        yield put(dealersSearchTimeZonesResult([]))
        ExceptionManager(exc, 'Modules/dealers/views/components/createEditDealer/redux/saga', 'searchTimezones');
    }
}

export const getSfAccount = async (input = '') => {
    try {
        let QUERY = `
        query searchSfAccount ($name: String, $limit: Int, $offset: Int) {
            result: searchSfAccount (name: $name, limit: $limit, offset: $offset) {
                items {
                    id
                    name
                }
            }
        }`
        return await clientQuery(QUERY, {
            name: input,
            limit: 15,
            offset: 0
        }, endpoints.GRAPHQL_GENERAL);
    } catch (exc) {
        ExceptionManager(exc, 'Modules/dealers/views/components/createEditDealer/redux/saga', 'getSfAccount');
    }
}

export const getAccounts = async (input = '') => {
    try {
        let QUERY = `
        query searchCompanies ($conditions: [CompanySearchInput], $sort: [CompanySortInput], $limit: Int, $offset: Int) {
            result: searchCompanies (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                items {
                    id
                    name
                    status
                    timezone
                    timezoneId
                    language
                }
            }
        }`
        return await clientQuery(QUERY, {
            conditions: {
                fields: [
                    "name"
                ],
                terms: [
                    input
                ],
                exact: false
            },
            limit: 10
        }, endpoints.GRAPHQL_GENERAL);
    } catch (exc) {
        ExceptionManager(exc, 'Modules/activities/.components/tab/redux/saga', 'searchAuditlogs');
    }
}

function* watchCatalogRequests() {
    yield takeEvery(DEALERS_CREATE_EDIT_DEALER_SEARCH_ROLES_REQUEST, searchRoles);
    yield takeEvery(DEALERS_CREATE_EDIT_DEALER_GET_ROLE_REQUEST, getRole);
    yield takeEvery(DEALERS_CREATE_EDIT_DEALER_GET_DEALER_REQUEST, getDealer);
    yield takeEvery(DEALERS_CREATE_DEALER_REQUEST, createDealer);
    yield takeEvery(DEALERS_CREATE_EDIT_DEALER_GET_CUSTOM_ROLE_REQUEST, getCustomRol);
    yield takeEvery(DEALERS_EDIT_DEALER_REQUEST, editDealer);
    yield takeEvery(DEALERS_CREATE_EDIT_DEALER_GET_ROLE_MODULES_TEMPLATE_REQUEST, searchTemplateRoleModules);
    yield takeEvery(DEALERS_CREATE_EDIT_DEALER_SEARCH_TIMEZONES_REQUEST, searchTimezones);
    yield takeEvery(DEALERS_CREDENCIAL_VALIDATION_REQUEST, credencialValidation);
}
//credencialValidation


//Saga Export
export default function* rootSaga() {
    yield all([
        fork(watchCatalogRequests)
    ]);
}